<script lang="ts">
  import type { ApiField } from '../data-tables-api';
  import type { Component } from 'svelte';
  import TextInput from './inputs/TextInput.svelte';
  import MultiLineInput from './inputs/MultiLineInput.svelte';
  import EmailInput from './inputs/EmailInput.svelte';
  import PhoneInput from './inputs/PhoneInput.svelte';
  import UrlInput from './inputs/UrlInput.svelte';
  import NumberInput from './inputs/NumberInput.svelte';
  import PercentInput from './inputs/PercentInput.svelte';
  import CurrencyInput from './inputs/CurrencyInput.svelte';
  import DatePicker from './inputs/DatePicker.svelte';
  import DateTimePicker from './inputs/DateTimePicker.svelte';
  import CheckboxInput from './inputs/CheckboxInput.svelte';
  import SelectInput from './inputs/SelectInput.svelte';
  import TagsInput from './inputs/TagsInput.svelte';
  import CountryPicker from './inputs/CountryPicker.svelte';
  import LinkedRecordInput from './inputs/LinkedRecordInput.svelte';
  import ReadonlyDisplay from './inputs/ReadonlyDisplay.svelte';

  type EditorComponent = Component<{
    field: ApiField;
    value: unknown;
    onChange: (v: unknown) => void;
    error?: string | null;
    disabled?: boolean;
  }>;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const EDITORS: Record<string, EditorComponent> = {
    single_line: TextInput as any,
    multi_line: MultiLineInput as any,
    email: EmailInput as any,
    phone: PhoneInput as any,
    url: UrlInput as any,
    number: NumberInput as any,
    auto_number: NumberInput as any,
    percent: PercentInput as any,
    currency: CurrencyInput as any,
    date: DatePicker as any,
    datetime: DateTimePicker as any,
    checkbox: CheckboxInput as any,
    dropdown: SelectInput as any,
    tags: TagsInput as any,
    country: CountryPicker as any,
    linked_record: LinkedRecordInput as any,
    formula: ReadonlyDisplay as any,
    stat: ReadonlyDisplay as any,
    linked_summary: ReadonlyDisplay as any,
  };

  let {
    field,
    value,
    onChange,
    error = null,
    disabled = false,
  }: {
    field: ApiField;
    value: unknown;
    onChange: (v: unknown) => void;
    error?: string | null;
    disabled?: boolean;
  } = $props();

  // Computed-поля та protected-readonly → завжди ReadonlyDisplay.
  const isReadonly = $derived(!!field.is_computed);
  const Editor = $derived(isReadonly ? ReadonlyDisplay : (EDITORS[field.type] ?? TextInput));
</script>

<Editor {field} {value} {onChange} {error} {disabled} />
